export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-align-right-b39b8cecec3022b8d237842e780b1805.svg";